import { Action } from '@ngrx/store'
import { Country } from '@spartacus/core'

export const LOAD_COUNTRIES = '[Site-context] Load Country'
export const LOAD_COUNTRIES_FAIL = '[Site-context] Load Country Fail'
export const LOAD_COUNTRIES_SUCCESS = '[Site-context] Load Countries Success'
export const SET_ACTIVE_COUNTRY = '[Site-context] Set Active Country'
export const COUNTRY_CHANGE = '[Site-context] Country Change'

export class LoadCountries implements Action {
  readonly type = LOAD_COUNTRIES
}

export class LoadCountriesFail implements Action {
  readonly type = LOAD_COUNTRIES_FAIL

  constructor (public payload: any) {
  }
}

export class LoadCountriesSuccess implements Action {
  readonly type = LOAD_COUNTRIES_SUCCESS

  constructor (public payload: Country[]) {
  }
}

export class SetActiveCountry implements Action {
  readonly type = SET_ACTIVE_COUNTRY

  constructor (public payload: string) {
  }
}

export class CountryChange implements Action {
  readonly type = COUNTRY_CHANGE

  constructor (public payload: { previous: string; current: string }) {
  }
}

// action types
export type CountriesActions =
  | LoadCountries
  | LoadCountriesFail
  | LoadCountriesSuccess
  | SetActiveCountry
  | CountryChange
